module.exports = __webpack_public_path__ + "static/media/vuelaverde2.59106937.jpg";